
<f-dialog
    v-model       = "value"
    :title        = "'Einstellungen ' + (customer ? customer.name : '')"
    :full-screen  = "true"
    :hide-actions = "true"
    @cancel       = "onClose"
>
    <template v-slot:content>
        <div>
            <v-tabs
                v-model      = "tab"
                class        = "mt-2 folder-tabs ml-0 mr-0 pr-0"
                active-class = "folder-tab-active primary"
                height       = "35"
                light
                show-arrows
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                    class="folder-tab"
                    :key="1"
                >
                    Standardmails
                </v-tab>
                <v-tab
                    class="folder-tab"
                    :key="2"
                >
                    Signaturen
                </v-tab>

                <v-tabs-items v-model="tab">
                    <v-tab-item :key="1">
                        <template-mails :customer="customer ? customer.id : null" ref="tab" />
                    </v-tab-item>

                    <v-tab-item :key="2">
                        <template-signatures ref="tab" />
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </template>
</f-dialog>
